const EASINGS = {
    EASE: 'ease',
    IN: 'ease-in',
    OUT: 'ease-out',
};

export default EASINGS;
